import React from 'react';
import { Link } from 'react-router-dom';
import firebase from 'firebase';
import Moment from 'react-moment';
import _ from 'lodash';

class Games extends React.Component {

	constructor(props) {
		super(props);
		this.state = {
			loaded : false,
			games : {}
		}
	}

	componentDidMount() {
		let self = this;
		firebase.database().ref('games/').on('value', (result) => {
			if(result.val()) {
				let games = result.val(),
					now = new Date().getTime(),
					oneWeekAgo = now - (1000*60*60*24*7);
					games = _.orderBy(games, 'created' ).reverse();
					games = _.filter(games, (game) => {
					return game.created > oneWeekAgo
				})
				self.setState({ games: games });
				self.setState({ loaded: true });
			}
			else {
				self.setState({ games: [] });
				self.setState({ loaded: true });
				console.warn("There are no active games")
			}
		});
	}

	handleSignoutClick() {
		// console.log('signout');
		firebase.auth().signOut()
		.then(response => {
			// console.log('signed out',response);
		})
		.catch(error => {
			console.warn('could not sign out',error);
		})
	}


	render() {

		return <section className="games">
		<header className="header">
			<h1>Join a Game</h1>
		</header>

		<main>

			{!this.state.loaded && <ul className="games -plain">
				<div className="loader">
					<div>
						<span></span>
						<span></span>
					</div>
				</div>
			</ul>}
			{this.state.games && <ul className="games -plain">
			{Object.keys(this.state.games).map(gameId =>
				<li key={gameId}>
					<Link to={`/join/${this.state.games[gameId].id}/`} className={`card game ${this.state.games[gameId].active ? '-active' : '-inactive'}  `}>
						<span className="side date"><Moment date={this.state.games[gameId].created} format="MMM DD" /></span>
						<h3>{this.state.games[gameId].name}</h3>
						<div className='button -secondary -outline'>Join</div>
					</Link>
				</li>
			)}
			</ul>}

		</main>

		<div className="actions ridged">
			<Link to={`/games/create`} className="button -primary -huge -icon -plane">
				Create A Game
			</Link>

			{/* {this.props.user && <a onClick={this.handleSignoutClick} className="button -temp -huge">Signout</a>} */}
		</div>

		</section>

		;
	}
}

export default Games



// WEBPACK FOOTER //
// ./src/components/games/index.js